// Maps error codes raised by the database functions (and common Supabase Auth errors) to plain copy.
const MESSAGES: Record<string, string> = {
  not_signed_in: 'Your session has ended. Please sign in again.',
  access_denied: 'Google sign-in was cancelled.',
  forbidden: "You don't have access to this. Ask a Food Committee admin to add you.",
  no_flat: 'Link this email to your flat first.',
  already_linked: 'This email is already in a family. Leave it first under My family to join another.',
  name_invalid: 'Enter a name (2 to 80 characters).',
  tower_invalid: 'Choose the tower.',
  invite_expired: 'This join link has expired or was already used. Ask whoever sent it for a new one.',
  invite_flat_pass_only: 'Scan the family pass (the QR for every meal) to show a join QR.',
  flat_invalid: 'Enter the flat as its floor and letter, for example 3B or 20F (floors 1 to 20).',
  phone_invalid: 'Enter a 10-digit Indian mobile number.',
  flat_has_members: 'This family already has an email in the portal.',
  no_family_here: 'No family at this flat uses the portal yet. Start your own instead.',
  too_many_requests: 'Too many requests today. Please try again tomorrow, or ask the help desk.',
  request_gone: 'That request was already answered or withdrawn. The list has been refreshed.',
  flat_change_has_orders: 'Your family has bookings for an event that is on, so the help desk changes the flat for you. Please ask them.',
  merge_other_flat: 'Only families at the same flat can be combined. Change one family\'s flat first.',
  merge_same_family: 'That is the same family.',
  claim_expired: 'This join link has expired or was already used. Ask whoever sent it for a new one.',
  email_invalid: 'Enter a valid email address.',
  email_other_flat: 'This email is already in another family. Leave that family first under My family, or ask the help desk to combine the two.',
  email_not_found: 'That email is not linked any more. The list has been refreshed.',
  too_many_emails: 'A family can have up to 10 emails.',
  cannot_remove_self: "You can't remove your own email here.",
  no_email: 'This flat has no email that gets notifications. Add an email first.',
  no_passes: 'This flat has no confirmed meals yet, so there are no passes to send.',
  flat_not_found: 'Flat not found. It may have been changed by someone else.',
  flat_exists: 'That tower and flat already exist. Search for it instead.',
  pay_mode_invalid: 'Choose how the flat paid.',
  sitting_over: 'One of the meals you picked has already finished. Remove it and try again.',
  booking_closed: 'Food booking is closed right now.',
  code_invalid: 'The event code is 2 to 8 letters or digits, like DP26.',
  code_taken: 'Another event already uses this code.',
  code_locked: 'Families have booked this event, so its code is in their order codes and can no longer change.',
  already_reported: 'Already reported. The Food Committee will look into it.',
  event_not_open: 'This event is not taking bookings. Pick meals from an event that is open.',
  mixed_events: 'One order can only have meals from one event. Book each event separately.',
  event_not_found: 'Event not found.',
  address_invalid: 'Keep the address to 200 characters.',
  event_needs_dates: "Set the event's first and last day before publishing it.",
  event_over: 'This event is over: its programme and page can no longer change.',
  dates_invalid: 'Pick a first and a last day, at most a month apart.',
  meals_outside_dates: 'Some meals fall outside these days. Move them first.',
  programme_outside_dates: 'Some programme entries fall outside these days. Move them first.',
  outside_event_dates: "Pick a day of the event (its dates are set under Events).",
  times_invalid: 'The end time must be after the start, within a day.',
  title_invalid: 'Give it a name of 2 to 80 characters.',
  topic_invalid: 'Pick what kind of programme it is.',
  programme_item_not_found: 'That programme entry is no longer there.',
  about_invalid: 'Keep the description to 600 characters.',
  contact_invalid: 'Each contact needs a name (2 to 60 characters) and a 10-digit phone number.',
  note_invalid: 'Each note needs a heading (2 to 60 characters) and some text (up to 800).',
  receipt_not_ready: 'The receipt is ready once the payment is confirmed.',
  cursor_invalid: 'This list has changed. Go back and open Past events again.',
  event_has_no_meals: 'Add at least one meal with a menu before publishing.',
  event_has_orders: 'Families have booked this event, so it can no longer go back to draft. Close it instead.',
  event_archived: 'This event is archived: it is view only and can\'t be reopened or changed. To run it again, copy it into a new event.',
  event_archive_closed_only: 'Close the event before archiving it.',
  test_mode_not_allowed: 'This site takes real payments only, so Cashfree test mode is turned off here. Save the live keys instead.',
  gateway_test_keys: 'These are Cashfree test keys (the App ID starts with TEST). This site takes real payments only: use the live keys from the Cashfree dashboard.',
  request_other_flat: 'That family is at a different flat from the one they asked about.',
  sitting_has_orders: 'Families have booked this meal, so it cannot be removed. Change its times instead.',
  menu_item_has_orders: 'Families have booked this menu, so it cannot be removed. Change it instead.',
  day_invalid: 'Enter the day (for example "Day 1" or "Saptami").',
  meal_invalid: 'Pick breakfast, lunch, snacks or dinner.',
  label_invalid: 'Keep the meal name to 40 characters.',
  cutoff_invalid: 'Booking must close before the meal ends.',
  date_invalid: 'Pick the first day of the event.',
  price_invalid: 'Enter prices between ₹0 and ₹1,00,000.',
  items_invalid: 'Keep the menu to 30 lines.',
  booking_closed_for_sitting: 'Booking has closed for one of the meals you picked. Remove it and try again.',
  invalid_lines: 'Something is wrong with this order. Please choose the meals again.',
  invalid_quantity: 'Each meal can have up to 20 adults and 20 children.',
  unknown_menu_item: 'The menu has changed. Reload the page and choose again.',
  duplicate_menu_item: 'The same meal is in the order twice. Choose again.',
  too_many_orders: 'Too many orders from this flat in the last hour. Please try again later.',
  bhog_cap: 'Your flat has reached the limit for free (Bhog) seats in this event.',
  bhog_cap_shared: 'Your flat has reached the limit for free (Bhog) seats in this event, counting what other families at your flat booked. If someone joined your flat by mistake, ask the help desk.',
  order_not_found: 'Order not found.',
  status_locked: 'This order can no longer be changed.',
  utr_format: 'Enter all 12 digits of the UTR, or just the last 4. Copy it from the payment details in your UPI app.',
  too_many_attempts: 'Too many UTR attempts on this order. Please contact the Food Committee.',
  bad_transition: 'Someone else has already updated this order. The list has been refreshed.',
  reason_required: 'Add a reason the resident will see.',
  order_has_serves: 'Meals from this order have already been served. Only an admin can change it.',
  bad_decision: 'Unknown action.',
  unknown_pass: 'This QR is not a ONE10 Food Pass.',
  wrong_sitting: 'This pass is for a different meal.',
  outside_window: 'This meal is not being served right now.',
  payment_not_verified: 'Payment not verified yet. Send them to the help desk.',
  over_limit: 'Those seats were just served at another counter. The pass has been refreshed.',
  nothing_to_serve: 'Choose at least one plate to serve.',
  no_booking: 'This flat has no booking for the meal being served.',
  seat_used: 'This single-seat pass has already been used.',
  seat_not_found: 'This single-seat pass no longer exists. The passes may have been reissued; refresh the page.',
  seat_served: 'This seat has already been served, so it can no longer be taken back.',
  no_free_seat: 'No free seat of this kind is left to keep for a guest at this meal.',
  too_many_reissues: 'New QR codes were issued several times today. Ask the Food Committee if you need them again.',
  request_key_required: 'Something went wrong. Scan the pass again.',
  counter_required: 'Choose which counter this is.',
  serve_not_found: 'That serve was already undone.',
  undo_expired: 'Undo is only available for 2 minutes after a serve. Ask an admin.',
  last_admin: "You can't remove the last admin.",
  sitting_not_found: 'Meal not found.',
  window_invalid: 'Closing time must be after opening time.',
  grace_invalid: 'Grace time must be between 0 and 240 minutes.',
  minutes_invalid: 'Choose between 5 and 240 minutes.',
  notice_invalid: 'Write a notice of 3 to 280 characters.',
  notice_not_found: 'That notice is gone. The list has been refreshed.',
  delay_needs_meal: 'Choose which meal is running late.',
  starts_invalid: 'Choose a start time within the next 7 days.',
  venue_invalid: 'Enter a venue name (up to 40 characters).',
  venue_not_found: 'Venue not found.',
  menu_item_not_found: 'Meal not found.',
  push_endpoint_invalid: "This browser's notification service isn't supported. Try Chrome or Safari.",
  push_keys_invalid: "This browser's notification keys look wrong. Turn alerts off and on again.",
  push_not_subscribed: 'Alerts are not on for this phone. Turn them on first.',
  setting_invalid: 'That value is not allowed.',
  online_off: 'Online payment is not available right now. Pay by UPI and send the UTR, or ask the Food Committee.',
  phone_required: 'Enter a 10-digit Indian mobile number: Cashfree needs it for the payment.',
  nothing_to_pay: 'There is nothing to pay on this order.',
  online_payment_open: 'An online payment for this order may still be in progress. Wait 30 minutes, or check its status first.',
  gateway_error: "Cashfree couldn't start the payment. Please try again in a minute, or pay by UPI and send the UTR.",
  gateway_unreachable: "Couldn't reach the payment page. Check your internet and try again.",
  gateway_keys_missing: 'Enter both the Cashfree App ID and Secret Key first.',
  gateway_key_invalid: "That doesn't look like a Cashfree key. Copy it again from the Cashfree dashboard.",
  account_invalid: 'Choose an account that is in use.',
  account_wrong_kind: "That account can't take this kind of payment (cash goes into a cash account, UPI into a UPI or bank account).",
  cash_not_recorded: 'Record who received the cash first ("Cash received"). A second person then approves it.',
  cash_second_person: 'You recorded this cash, so someone else on the Food Committee approves it.',
  cash_already_recorded: 'This cash has already been recorded.',
  paid_online: 'Cashfree confirmed this payment. Only an admin can reopen it.',
  statement_empty: 'No credits found in that file. Check the columns you picked.',
  statement_too_long: 'Upload up to 5,000 rows at a time.',
  statement_row_invalid: "A row has a date or amount we can't read. Check the columns you picked.",
  statement_line_not_found: 'That statement line is gone. The list has been refreshed.',
  statement_line_used: 'That line is already linked or set aside. The list has been refreshed.',
  order_has_statement: 'That order is already linked to another statement line.',
  amount_mismatch: "The amounts don't match. Check the order, or use \"Link anyway\" if you're sure.",
  setting_unknown: 'Unknown setting.',
};

export function errorText(e: unknown): string {
  const raw = e instanceof Error ? e.message : typeof e === 'string' ? e : '';
  const code = raw.trim();
  if (MESSAGES[code]) return MESSAGES[code];
  const lower = code.toLowerCase();
  if (lower.includes('token has expired') || lower.includes('otp has expired') || (lower.includes('invalid') && (lower.includes('otp') || lower.includes('token')))) {
    return 'That code is wrong or has expired. Check the latest email, or ask for a new code.';
  }
  // The email hook refused (hourly limit for this address, or the email service failed).
  if (lower.includes('hook')) {
    return "We couldn't email a code right now. If you asked for several codes, wait an hour and try again.";
  }
  if (lower.includes('email rate limit')) return 'Too many sign-in emails were sent in the last hour. Please try again later.';
  if (lower.includes('you can only request this after') || lower.includes('rate limit') || lower.includes('too many')) {
    return 'Please wait a minute before asking for another code.';
  }
  if (lower.includes('signups not allowed') || lower.includes('signup is disabled')) return 'New sign-ups are closed. Ask the Food Committee.';
  if (lower.includes('captcha')) return 'The bot check failed. Please try again.';
  if (lower.includes('failed to fetch') || lower.includes('network') || lower.includes('load failed')) {
    return 'No connection. Check your internet and try again.';
  }
  return code || 'Something went wrong. Please try again.';
}

/** For a ClaimResult error code (claim_start returns errors instead of raising them). */
export const claimErrorText = (code: string | undefined) => errorText(code ?? '');
